export default __webpack_public_path__ + "static/cashflow_202_1996_6-4114e03f902873e01c6890a05a72a10b.jpeg";